import { render, staticRenderFns } from "./JSelectBanjiByZy.vue?vue&type=template&id=88942c8a&scoped=true"
import script from "./JSelectBanjiByZy.vue?vue&type=script&lang=js"
export * from "./JSelectBanjiByZy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88942c8a",
  null
  
)

export default component.exports